export default "__VITE_ASSET__DdWybODs__"